export default __webpack_public_path__ + "static/Above-Ground-Pool-Removal-b467bfc1b277cf0309bccf74af573f58.jpg";